<script>
import { mapGetters } from 'vuex'
import api from '@services/api'

export default {
  name: 'WithAllLayouts',
  props: {
    type: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      allLayouts: [],
      layoutsLoading: false,
      layoutsError: false,
    }
  },
  computed: {
    ...mapGetters('auth', ['loggedIn']),
    ...mapGetters('site', ['getLocationSummary']),
  },
  watch: {
    loggedIn: {
      handler(val) {
        if (val) this.loadAllLayouts()
      },
      immediate: true,
    },
  },
  methods: {
    async loadAllLayouts() {
      const locations = this.getLocationSummary
      if (!locations || !locations.length) return
      this.layoutsLoading = true
      this.layoutsError = false
      try {
        const params = this.type ? { type: this.type } : {}
        const results = await Promise.all(
          locations.map((loc) =>
            api
              .get(`/locations/${loc.id}/layouts`, { params })
              .then((r) => ({
                locationTitle: loc.title,
                locationSlug: loc.slug,
                layouts: r.data || [],
              }))
              .catch((err) => {
                console.error(err)
                return null
              })
          )
        )
        const filtered = results.filter(Boolean)
        if (filtered.length === 0 && results.some((r) => r === null)) {
          this.layoutsError = true
        }
        this.allLayouts = filtered
      } finally {
        this.layoutsLoading = false
      }
    },
  },
  render() {
    return this.$scopedSlots.default({
      allLayouts: this.allLayouts,
      layoutsLoading: this.layoutsLoading,
      layoutsError: this.layoutsError,
    })
  },
}
</script>
